<template>
  <a href="https://fire-emblem-heroes.com/" target="_blank" class="btn-official">
    <BtnBlue>
      <p class="txt" :class="[this.$route.params.lang]" v-html="$t('btn.officialwebsite')" />
    </BtnBlue>
  </a>
</template>
<script>
import BtnBlue from '@components/global/button-blue.vue'
import localeCommon from '@locales/common'

export default {
  $messages: localeCommon,
  components: {
    BtnBlue,
  },
}
</script>
<style lang="scss" scoped>
.btn-official {
  display: block;
  margin: 40px 7.4%;
  /deep/ .button-inner {
    height: 100px;
  }
  .txt {
    position: absolute;
    @include hidden-text();
    background-repeat: no-repeat;
    background-position: center center;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    &.ja-JP {
      background-image: url(#{$img-path}common/ja-JP/txt_to-official.png);
    }
    &.de-DE {
      background-image: url(#{$img-path}common/de-DE/txt_to-official.png);
    }
    &.en-GB {
      background-image: url(#{$img-path}common/en-GB/txt_to-official.png);
    }
    &.en-US {
      background-image: url(#{$img-path}common/en-US/txt_to-official.png);
    }
    &.es-ES {
      background-image: url(#{$img-path}common/es-ES/txt_to-official.png);
    }
    &.es-MX {
      background-image: url(#{$img-path}common/es-MX/txt_to-official.png);
    }
    &.fr-CA {
      background-image: url(#{$img-path}common/fr-CA/txt_to-official.png);
    }
    &.fr-FR {
      background-image: url(#{$img-path}common/fr-FR/txt_to-official.png);
    }
    &.it-IT {
      background-image: url(#{$img-path}common/it-IT/txt_to-official.png);
    }
    &.pt-BR {
      background-image: url(#{$img-path}common/pt-BR/txt_to-official.png);
    }
    &.zh-TW {
      background-image: url(#{$img-path}common/zh-TW/txt_to-official.png);
    }
  }
}
</style>